<template>
  <div>
    <el-drawer
      v-if="visible"
      :visible.sync="visible"
      :size="1000"
      :title="title"
      append-to-body
      :with-header="false"
      :before-close="handleClose"
    >
      <div class="d-flex" style="justify-content: space-between; margin: 20px;">
        <div style="color: #101010;font-size: 14px;">
          {{ $l('drawer_header_inspection_detail_title') || '检验信息' }}
        </div>
        <div>
          <el-button
            v-if="!disabled"
            size="mini"
            style="width: 80px;"
            type="primary"
            @click="$refs.inspectionInfoForm.save()"
          >
            {{ $l('INDEX.btn_save') || '保存' }}
          </el-button>
          <el-button size="mini" style="width: 80px;" @click="handleClose()">
            {{ $l('INDEX.btn_close') || '关闭' }}
          </el-button>
        </div>
      </div>

      <InspectionInfoForm
        class="m-4"
        ref="inspectionInfoForm"
        :disabled="disabled"
        :inspectionDetailCode="inspectionDetailCode"
        :inspectionCode="inspectionCode"
        @close="close"
        :totalArrivalQuantity="totalArrivalQuantity"
      />
    </el-drawer>
    <CloseDialog :backDialogVisible.sync="backDialogVisible" @close="close" />
  </div>
</template>
<script>
import InspectionInfoForm from './index.vue'
import CloseDialog from '../close-dialog/index.vue'
export default {
  components: {
    InspectionInfoForm,
    CloseDialog,
  },
  props: {
    visible: { type: Boolean, default: false },
    totalArrivalQuantity: { type: Number, default: 0 },
    disabled: { type: Boolean, default: false },
    title: { type: String, default: '' },
    inspectionDetailCode: { type: String, default: '' },
    inspectionCode: { type: String, default: '' },
  },
  data() {
    return {
      backDialogVisible: false,
    }
  },

  methods: {
    close() {      
      this.$emit('update:visible', false)
      this.$emit('close')
    },

    handleClose() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
  },
}
</script>
